// extracted by mini-css-extract-plugin
module.exports = {"found":"CompareBuildsFilter__found--MK"};